import React from 'react';
import moment from 'moment';
import { get } from 'lodash';
import TableHeader from '../TableHeader';

import AdjustPointInput from './AdjustPointInput'

const UserCampaignsList = ({ users = [], total = 0, campaignId = 0, userId }) => {
  const onSubmit = (e) => {
    e.preventDefault()

    const $els = e.target.elements
    const userId = get($els, 'userId.value')

    window.location.href = `/${gon.currentProvider}/campaigns/${campaignId}/user_campaigns?user_id=${userId}`
  }

  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>User Campaigns list</h2>
          <p className='MainHeader__left__p'>Total {total.toLocaleString()} users participant in the campaign</p>
        </div>

        <div className='MainHeader__right'>
          <form
            className='Container__search'
            onSubmit={onSubmit}
          >
            <input
              type='number'
              className='Input Input__inline'
              name='userId'
              placeholder='Search by user id'
              defaultValue={userId}
            />
          </form>
        </div>
      </div>

      <div className='Table Table--user-campaign-list'>
        {(() => {
          const columnHeaders = [
            {
              label: 'User ID'
            },
            {
              label: 'Current Pt.'
            },
            {
              label: 'Adjust Pt.'
            },
            {
              label: 'Rank'
            },
            {
              label: 'Rank valid until'
            },
            {
              label: 'Details'
            },
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}

        {users.map((user) => (
          <div className={'Table__row'} key={`user_${user.userId}`}>
            <div className='Table__col'>
              <a className='DotTooltip__link' href={`/${gon.currentProvider}/users/${user.userId}`}>{user.userId}</a>
            </div>

            <div className='Table__col'>{user.points || 0}</div>

            <div className='Table__col'>
              <AdjustPointInput
                campaignId={campaignId}
                userId={user.userId}
              />
            </div>

            <div className='Table__col'>{user.ranking || 'out of range'}</div>

            <div className='Table__col'>
              {user.rankingValidUntil ?
                moment(get(user, 'rankingValidUntil')).format('YYYY-MM-DD HH:mm')
              :
                '-'
              }
            </div>

            <div className='Table__col'>
              <a className='DotTooltip__link' href={`/${gon.currentProvider}/campaigns/${campaignId}/users/${user.userId}/user_missions`}>Missions</a>
              &nbsp;|&nbsp;
              <a className='DotTooltip__link' href={`/${gon.currentProvider}/campaigns/${campaignId}/users/${user.userId}/point_histories`}>Point Histories</a>
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default UserCampaignsList
